import Swiper from "swiper/bundle";

const ThreeSlidesSlider = () => {
  const threeSlidesBlocks = Array.from(document.querySelectorAll(".slider__block.three-slides"));
  if (threeSlidesBlocks.length <= 0) return;

  const initializeSlider = () => {
    threeSlidesBlocks.forEach((threeSlidesBlock) => {
      const threeSlidesSlider = threeSlidesBlock.querySelector(".slider__container");
      const pagination = threeSlidesBlock.querySelector(".slider__pagination");
      const btns = threeSlidesBlock.querySelector(".slider__btns");
      const nextBtn = threeSlidesBlock.querySelector(".slider__btn-next");
      const prevBtn = threeSlidesBlock.querySelector(".slider__btn-prev");
      const slides = Array.from(threeSlidesSlider.querySelectorAll(".swiper-slide"));

      const minSlidesForMobile = 1;
      const minSlidesForTablet = 2;
      const minSlidesForDesktop = 3;

      const shouldInitializeSlider =  (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop) ||
                                        (window.innerWidth < 1024 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
                                        (window.innerWidth < 768 && slides.length > minSlidesForMobile);
        

      if (!shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.add("d-none");
          pagination.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.remove("d-none");
          pagination.classList.remove("d-none");
        }

        const threeSlidesCarousel = new Swiper(threeSlidesSlider, {
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            0: {
              slidesPerView: "auto",
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
          },
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    threeSlidesBlocks.forEach((threeSlidesBlock) => {
      const threeSlidesSlider = threeSlidesBlock.querySelector(".slider__container");

      const swiperInstance = threeSlidesSlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
};

export default ThreeSlidesSlider;


